module.exports = __webpack_public_path__ + "img/circle_white_expanded.d8eaccab.png";